import React from 'react';
import Button from '@meitu/saas-ui/es/button';
import { useSvgModel } from '@/store/models/svg-model';
import { ISvgInfo, Shape } from '../../types';

interface IProps {
    svgInfo: ISvgInfo;
    curShape: Shape;
}
const Shapes: React.FC<IProps> = (props) => {
    const { svgInfo, curShape } = props;
    const setCurShape = useSvgModel((state) => state.setCurShape);
    const SvgKeys = Object.keys(svgInfo).slice(0, 2) as Shape[];
    return (
        <div className="design-svg-shape">
            <div className="design-svg-title"> 形状：</div>
            <div className="design-svg-shape__btn">
                {SvgKeys.map((item, index) => {
                    return (
                        <Button
                            type={curShape === SvgKeys[index] ? 'primary' : 'default'}
                            className="design-svg-shape__name"
                            key={index}
                            onClick={() => {
                                setCurShape(item);
                            }}
                        >
                            {svgInfo[item].shape}
                        </Button>
                    );
                })}
            </div>
        </div>
    );
};
export default React.memo(Shapes);
